const TakeawayEvent = ({ event, getPlayerName, getTeamAbbreviation }) => {
    const takeawayPlayerId = event.details?.takeawayPlayerId;
    const takeawayPlayerName = getPlayerName(takeawayPlayerId);
    const takeawayPlayerMugshotUrl = takeawayPlayerId ? `https://assets.nhle.com/mugs/nhl/20242025/${getTeamAbbreviation(event.details?.eventOwnerTeamId)}/${takeawayPlayerId}.png` : null;

    return (
        <div className="flex items-center mb-2">
            <span className="text-sm font-semibold text-gray-700 mr-2">Time:</span>
            <span className="text-sm text-gray-900 mr-2">{event.timeInPeriod}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">Period:</span>
            <span className="text-sm text-gray-900 mr-2">{event.periodDescriptor.number}</span>
            <span className="text-sm font-semibold text-gray-700 mr-2">{takeawayPlayerName}</span>
            {takeawayPlayerMugshotUrl && (
                <img
                    src={takeawayPlayerMugshotUrl}
                    alt={takeawayPlayerName}
                    className="inline-block ml-2 w-8 h-8 rounded-full"
                />
            )}
            <span className="text-sm font-semibold text-gray-700 ml-2">Takeaway</span>
        </div>
    );
};

export default TakeawayEvent;